import { Link } from 'react-router-dom';
import styles from './Landing.module.css';

export default function Landing() {
  return (
    <div className={styles.landing}>
      {/* Header */}
      <header className={styles.header}>
        <div className={styles.container}>
          <div className={styles.logo}>
            <h1>Control Escolar</h1>
          </div>
          <nav className={styles.nav}>
            <a href="#features">Características</a>
            <a href="#modules">Módulos</a>
            <a href="#contact">Contacto</a>
            <Link to="/login" className={styles.loginBtn}>
              Iniciar Sesión
            </Link>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className={styles.hero}>
        <div className={styles.container}>
          <div className={styles.heroContent}>
            <h2>Sistema Integral de Gestión Escolar</h2>
            <p className={styles.heroSubtitle}>
              Plataforma profesional diseñada para instituciones educativas modernas. 
              Gestiona alumnos, finanzas, asistencia y más en un solo lugar.
            </p>
            <div className={styles.heroCta}>
              <Link to="/login" className={styles.primaryBtn}>
                Acceder al Sistema
              </Link>
              <a href="#contact" className={styles.secondaryBtn}>
                Solicitar Demo
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section id="features" className={styles.features}>
        <div className={styles.container}>
          <h3 className={styles.sectionTitle}>¿Por qué elegirnos?</h3>
          <div className={styles.featuresGrid}>
            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>📊</div>
              <h4>Gestión Centralizada</h4>
              <p>
                Toda la información de tu institución en una sola plataforma. 
                Alumnos, profesores, finanzas y comunicación integrados.
              </p>
            </div>
            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>🔒</div>
              <h4>Seguridad y Control</h4>
              <p>
                Roles y permisos granulares. Control total sobre quién accede 
                a qué información dentro de tu institución.
              </p>
            </div>
            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>⚡</div>
              <h4>Acceso en Tiempo Real</h4>
              <p>
                Información actualizada al instante. Reportes, asistencia y 
                calificaciones disponibles cuando los necesites.
              </p>
            </div>
            <div className={styles.featureCard}>
              <div className={styles.featureIcon}>📱</div>
              <h4>Multiplataforma</h4>
              <p>
                Accesible desde cualquier dispositivo. Diseñado para funcionar 
                perfectamente en computadoras, tablets y móviles.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Modules Section */}
      <section id="modules" className={styles.modules}>
        <div className={styles.container}>
          <h3 className={styles.sectionTitle}>Módulos Incluidos</h3>
          <p className={styles.sectionSubtitle}>
            Solución completa para todas las áreas de tu institución educativa
          </p>
          <div className={styles.modulesGrid}>
            <div className={styles.module}>
              <h5>📚 Gestión Académica</h5>
              <ul>
                <li>Control de alumnos y grupos</li>
                <li>Calificaciones y boletas</li>
                <li>Asistencia automatizada</li>
                <li>Horarios y materias</li>
                <li>Tareas y seguimiento</li>
              </ul>
            </div>
            <div className={styles.module}>
              <h5>💰 Administración</h5>
              <ul>
                <li>Colegiaturas y pagos</li>
                <li>Facturación electrónica</li>
                <li>Control de becados</li>
                <li>Reportes financieros</li>
                <li>Gestión de morosos</li>
              </ul>
            </div>
            <div className={styles.module}>
              <h5>👥 Recursos Humanos</h5>
              <ul>
                <li>Control de personal</li>
                <li>Asistencia de empleados</li>
                <li>Nómina y prestaciones</li>
                <li>Evaluaciones de desempeño</li>
                <li>Capacitaciones</li>
              </ul>
            </div>
            <div className={styles.module}>
              <h5>📢 Comunicación</h5>
              <ul>
                <li>Avisos y circulares</li>
                <li>Mensajería interna</li>
                <li>Encuestas y sondeos</li>
                <li>Notificaciones push</li>
                <li>Calendario escolar</li>
              </ul>
            </div>
            <div className={styles.module}>
              <h5>🏥 Servicios</h5>
              <ul>
                <li>Control médico</li>
                <li>Comedor escolar</li>
                <li>Transporte</li>
                <li>Seguridad y accesos</li>
                <li>Reportes de incidentes</li>
              </ul>
            </div>
            <div className={styles.module}>
              <h5>📈 Reportes</h5>
              <ul>
                <li>Dashboard ejecutivo</li>
                <li>Reportes personalizados</li>
                <li>Estadísticas en tiempo real</li>
                <li>Exportación a Excel/PDF</li>
                <li>Análisis de tendencias</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className={styles.contact}>
        <div className={styles.container}>
          <h3 className={styles.sectionTitle}>Contacto</h3>
          <div className={styles.contactContent}>
            <p className={styles.contactIntro}>
              ¿Interesado en implementar nuestro sistema en tu institución? 
              Contáctanos para una demostración personalizada.
            </p>
            <div className={styles.contactInfo}>
              <div className={styles.contactItem}>
                <strong>Email:</strong>
                <a href="mailto:osesli@gmail.com">osesli@gmail.com</a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className={styles.footer}>
        <div className={styles.container}>
          <p>&copy; {new Date().getFullYear()} Control Escolar. Sistema de gestión institucional.</p>
        </div>
      </footer>
    </div>
  );
}
